export const flowSurveyZH = {
  flowSurvey1: 'BLOOM平台调研',
  flowSurvey2: '请问你是从哪些渠道了解到我们的平台活动呢？',
  flowSurvey3: '这有利于你更好地接收我们的活动信息哦~（多选）',
  flowSurvey4: '校内宣讲会',
  flowSurvey5: '社团推荐',
  flowSurvey6: '老师推荐',
  flowSurvey7: '同学/朋友推荐',
  flowSurvey8: '家长推荐',
  flowSurvey9: '中介/机构',
  flowSurvey10: '公众号',
  flowSurvey11: '视频号',
  flowSurvey12: '小红书',
  flowSurvey13: '抖音',
  flowSurvey14: '其他',
  flowSurvey15: '请填写其他了解渠道',
  flowSurvey16: '跳过',
  flowSurvey17: '提交',
  flowSurvey18: '已跳过问卷，感谢你的时间',
  flowSurvey19: '提交成功！感谢参与 🎉',
  flowSurvey20: '请填写具体的渠道信息'
}

export const flowSurveyEN = {
  flowSurvey1: 'BLOOM Platform Survey',
  flowSurvey2: 'How did you learn about our activities?',
  flowSurvey3: 'This helps us deliver activity info to you better~ (Select all that apply)',
  flowSurvey4: 'School Info Session',
  flowSurvey5: 'School Club Recommendation',
  flowSurvey6: 'Teacher',
  flowSurvey7: 'Friends / Classmate',
  flowSurvey8: 'Parent',
  flowSurvey9: 'Education Agency',
  flowSurvey10: 'WeChat Official Account',
  flowSurvey11: 'WeChat Channels',
  flowSurvey12: 'Xiaohongshu (RedNote)',
  flowSurvey13: 'Douyin (TikTok China)',
  flowSurvey14: 'Other',
  flowSurvey15: 'Please specify',
  flowSurvey16: 'Skip',
  flowSurvey17: 'Submit',
  flowSurvey18: 'Survey skipped, thank you for your time',
  flowSurvey19: 'Submitted! Thank you for participating 🎉',
  flowSurvey20: 'Please enter specific channel info'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/survey.js